module.exports = __webpack_public_path__ + "img/797.2a84da0f.gif";